import { Injectable } from '@angular/core';
import { BaseTokenService } from 'projects/core/src/lib/services/base-token.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService extends BaseTokenService {

  protected id = 'acr_admin';

}
